import store from '../store';

import {
  SET_NOTIFICATIONS,
  CLEAR_LOST_NOTIFICATION,
  CLEAR_ACCEPTED_NOTIFICATION,
  SET_NOTIFICATION_POLL_TIME,
} from '../constants/AppConstants';

import {
  getNotifications as _getNotifications
} from '../../services/Notifications'

export const setNotificationPollTime = (pollTime, lastRequestTime) => {
  return {
    type: SET_NOTIFICATION_POLL_TIME,
    payload: { pollTime, lastRequestTime }
  }
}

export const countDownNotificationPollTime = () => {
  return async dispatch => {
    try {
      const { pollTime, lastRequestTime } = store.getState().notification;
      if (pollTime === 0) {
        dispatch(getNotifications());
      }
      if (pollTime >= 0) {
        dispatch(setNotificationPollTime(pollTime - 1, lastRequestTime));
      }
      setTimeout(() => {
        dispatch(countDownNotificationPollTime());
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }
}

const setNotifications = ({ added, updated, lost, accepted }) => {
  return {
    type: SET_NOTIFICATIONS,
    payload: { added, updated, lost, accepted },
  }
}

export const clearLostNotification = (serviceID) => {
  return {
    type: CLEAR_LOST_NOTIFICATION,
    payload: { serviceID }
  }
}

export const clearAcceptedNotification = (serviceID) => {
  return {
    type: CLEAR_ACCEPTED_NOTIFICATION,
    payload: { serviceID }
  }
}

export const getNotifications = () => {
  return async dispatch => {
    try {
      const { lastRequestTime } = store.getState().notification;
      const response = await _getNotifications({ lastRequestTime });
      if (response.resStatus == 200) {
        const { pollTime, requestedAt, added, updated, lost, accepted } = response.data;
        dispatch(setNotificationPollTime(pollTime, requestedAt));
        dispatch(setNotifications({ added, updated, lost, accepted }));
      }
    } catch (error) {
      console.log(error);
    }
  }
};

